<template>
  <v-toolbar dark dense class="primary">
    <v-toolbar-title>Alpine Leasing Rental Application</v-toolbar-title>
    <v-spacer />
    <update-fee></update-fee>
    <v-btn text v-if="isAdmin" @click="$router.push('/address')"
      >Listings</v-btn
    >
    <v-btn text v-else @click="$router.push('/admin')">Admin</v-btn>
    <v-btn text @click="logout">Logout</v-btn>
  </v-toolbar>
</template>

<script>
import { auth } from "../assets/js/firebase.js";
import UpdateFee from "./UpdateFee.vue";
export default {
  components: {
    UpdateFee,
  },
  computed: {
    isAdmin() {
      return this.$route.name === "admin";
    },
  },
  methods: {
    logout() {
      const vm = this;
      const check = confirm("Are you sure?");
      if (!check) return;
      vm.$root.loader = true;
      auth
        .signOut()
        .then(() => {
          vm.$root.loader = false;
          vm.$router.replace("/login");
        })
        .catch(() => {
          vm.$root.loader = false;
          vm.$router.replace("/login");
        });
    },
  },
};
</script>

<style></style>
